module.exports = __webpack_public_path__ + "1440baf1ce422649e410fe1714874041.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/img/name-female-2.svg
// module id = 83
// module chunks = 0